import {
  FIELD_TYPE,
} from './Constants';
import { FEATURE } from './Features';

interface IFieldTexts {
  label: string;
  invalid: string;
  required: string;
  maxLength?: string;
  minLength?: string;
}

type FieldLabelMap = {
  [key in FIELD_TYPE]?: IFieldTexts;
};

export const translationKeysFieldMappings: FieldLabelMap = {
  [FIELD_TYPE.FIRST_NAME]: {
    invalid: 'firstNameInvalid',
    label: 'firstName',
    maxLength: 'firstNameInvalid',
    required: 'firstNameRequired',
  },
  [FIELD_TYPE.LAST_NAME]: {
    invalid: 'lastNameInvalid',
    label: 'lastName',
    maxLength: 'lastNameInvalid',
    required: 'lastNameRequired',
  },
  [FIELD_TYPE.FIRST_NAME_ALTERNATE]: {
    invalid: 'firstNameAlternateInvalid',
    label: 'firstNameAlternate',
    required: 'firstNameAlternateRequired',
  },
  [FIELD_TYPE.LAST_NAME_ALTERNATE]: {
    invalid: 'lastNameAlternateInvalid',
    label: 'lastNameAlternate',
    required: 'lastNameAlternateRequired',
  },
  [FIELD_TYPE.FULL_NAME]: {
    invalid: 'fullNameInvalid',
    label: 'fullName',
    maxLength: 'fullNameInvalid',
    required: 'fullNameRequired',
  },
  [FIELD_TYPE.PHONE]: {
    invalid: 'mobileNumberInvalid',
    label: 'mobileNumber',
    required: 'mobileNumberRequired',
  },
  [FIELD_TYPE.SECOND_PHONE]: {
    invalid: 'mobileNumberInvalid',
    label: 'mobileNumber',
    maxLength: 'mobileNumberInvalid',
    minLength: 'mobileNumberInvalid',
    required: 'mobileNumberRequired',
  },
  [FIELD_TYPE.FIRST_LINE_ADDRESS]: {
    invalid: 'addAddressInvalid',
    label: 'firstLineAddress',
    maxLength: 'addAddressInvalid',
    minLength: 'addAddressInvalid',
    required: 'addressRequired',
  },
  [FIELD_TYPE.SECOND_LINE_ADDRESS]: {
    invalid: 'secondLineAddressInvalid',
    label: 'secondLineAddress',
    maxLength: 'addAddressInvalid',
    minLength: 'addAddressInvalid',
    required: 'secondLineAddressRequired',
  },
  [FIELD_TYPE.THIRD_LINE_ADDRESS]: {
    invalid: 'thirdLineAddressInvalid',
    label: 'thirdLineAddress',
    maxLength: 'thirdLineAddressInvalid',
    minLength: 'thirdLineAddressInvalid',
    required: 'thirdLineAddressRequired',
  },
  [FIELD_TYPE.FOURTH_LINE_ADDRESS]: {
    invalid: 'fourthLineAddressInvalid',
    label: 'fourthLineAddress',
    maxLength: 'fourthLineAddressInvalid',
    minLength: 'fourthLineAddressInvalid',
    required: 'fourthLineAddressRequired',
  },
  [FIELD_TYPE.FIFTH_LINE_ADDRESS]: {
    invalid: 'fifthLineAddressInvalid',
    label: 'fifthLineAddress',
    maxLength: 'fifthLineAddressInvalid',
    minLength: 'fifthLineAddressInvalid',
    required: 'fifthLineAddressRequired',
  },
  [FIELD_TYPE.DISTRICT]: {
    invalid: 'districtInvalid',
    label: 'district',
    maxLength: 'districtInvalid',
    minLength: 'districtInvalid',
    required: 'districtRequired',
  },
  [FIELD_TYPE.CITY]: {
    invalid: 'cityInvalid',
    label: 'city',
    maxLength: 'cityInvalid',
    minLength: 'cityInvalid',
    required: 'cityRequired',
  },
  [FIELD_TYPE.STATE]: {
    invalid: 'stateInvalid',
    label: 'state',
    required: 'stateRequired',
  },
  [FIELD_TYPE.EMAIL]: {
    invalid: 'emailInvalid',
    label: 'email',
    required: 'emailRequired',
  },
  [FIELD_TYPE.MOBILE_PHONE]: {
    invalid: 'mobileNumberInvalid',
    label: 'mobileNumber',
    required: 'mobileNumberRequired',
  },
};

export const disabledFieldsByFeature: Record<FEATURE, FIELD_TYPE[]> = {
  [FEATURE.PRO_CUSTOMER]: [
    FIELD_TYPE.FIRST_NAME,
    FIELD_TYPE.LAST_NAME,
    FIELD_TYPE.FIRST_NAME_ALTERNATE,
    FIELD_TYPE.LAST_NAME_ALTERNATE,
  ],
};
